import { SET_FILTER } from './constants';

export interface SetFilterAction {
  type: typeof SET_FILTER;
  dateFrom: Date;
  dateTo: Date;
}

export const setFilterAction = (dateFrom: Date, dateTo: Date): SetFilterAction => ({
  type: SET_FILTER,
  dateFrom,
  dateTo,
});

export type Actions = SetFilterAction;
